import { SegmentEntity } from "../../domain/segment.entity";
import { Segment } from "../../../../../gen/witbooking/backoffice/orchestrator/segment/v1/segment_api_pb";

export class SegmentMapper {
  static toDomain(proto: Segment): SegmentEntity {
    const obj = proto.toObject();
    return {
      id: obj.id,
      active: obj.active,
      ticker: obj.ticker,
      name: obj.name,
      description: obj.description,
    };
  }

  static toDomainArray(protos: Segment[]): SegmentEntity[] {
    return protos.map(proto => SegmentMapper.toDomain(proto));
  }

  static toProto(entity: SegmentEntity): Segment {
    const segment = new Segment();
    segment.setId(entity.id);
    segment.setActive(entity.active);
    segment.setTicker(entity.ticker);
    segment.setName(entity.name);
    segment.setDescription(entity.description);
    return segment;
  }
}
